// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.resellerreturnordercreate', {
        url: '/newreturnorder/',
        templateUrl: 'main/resellerorder/resellerreturnordercreate/resellerreturnordercreate.tpl.html',
        controller: 'ResellerReturnOrderCreateController as vm',
        resolve: {
            resellerOrder: function() {
                return {
                    links: [],
                    order: {
                        externalOrderNumber: '',
                        id: 0,
                        // lineItems: [],
                        resellerId: 0,
                        saleLocationId: 0,
                        status: 'Created',
                        warehouseId: 0
                    }
                };
            }
        },
        params: {
        }
    });
}

// @ngInject
function ResellerReturnOrderCreateController($rootScope, $state, $translate, resellerOrder, ResellerOrdersApiService, confirmationDialogService, loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    vm.resellerOrder = resellerOrder.order;
    vm.resellerOrder.links = resellerOrder.links;
    vm.links = resellerOrder.links;
    vm.canAccess = $rootScope.canAccess;

    //Public methods
    vm.canCreateOrderHeader = canCreateOrderHeader;
    vm.createOrderHeader = createOrderHeader;
    vm.createNewOrder = createNewOrder;

    activate();

    function activate() {
    }

    function createNewOrder() {
        $state.go('resellerorder.resellerordercreate');
    }

    function canCreateOrderHeader() {
        var hasSetReseller = vm.resellerOrder.resellerId > 0;
        var hasSetSaleLocation = vm.resellerOrder.saleLocationId > 0;
        var hasSetWarehouse = vm.resellerOrder.warehouseId > 0;
        var hasSetCollection = vm.resellerOrder.collectionId > 0;

        return hasSetReseller && hasSetSaleLocation && hasSetWarehouse && hasSetCollection;
    }

    function createOrderHeader() {
        //call backend, save order
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.createReturnOrder(vm.resellerOrder).then(function (response) {
            var orderId = response.data.id;
            $state.go('resellerorder.resellerreturnordermodify', { orderId: orderId });
        }, function (error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('resellerorder.resellerreturnordercreate', [])
    .config(stateConfig)
    .controller('ResellerReturnOrderCreateController', ResellerReturnOrderCreateController);
